import React from 'react';

import { generatePath, Link as RouterLink, useParams } from 'react-router-dom';

import { Divider } from '../../components/divider';
import { Logo } from '../../components/logo';
import { Stack } from '../../components/stack';
import { useFenrirTranslation } from '../../locales/use-fenrir-translation';

export type DashboardAppBarContentProps = React.PropsWithChildren<{
  hideDivider?: boolean;
  routePrefix: string;
}>;

/** @experimental In active development. Avoid using until further notice. */
export const DashboardAppBarContent = ({
  children,
  hideDivider = false,
  routePrefix,
}: DashboardAppBarContentProps) => {
  const { t } = useFenrirTranslation({ keyPrefix: 'dashboardLayout' });
  const params = useParams();
  const to = generatePath(routePrefix, params);

  return (
    <>
      <Stack direction="row" spacing={2}>
        <RouterLink to={to} aria-label={t('navigation.goBackHome')}>
          <Logo width={80} />
        </RouterLink>
      </Stack>
      {!hideDivider && (
        <Divider
          orientation="vertical"
          flexItem
          variant="middle"
          sx={{
            margin: 2,
          }}
        />
      )}

      {children}
    </>
  );
};
